// extracted by mini-css-extract-plugin
export default {"warning":"substitutions_warning__KTQ1V","oldDate":"substitutions_oldDate__zixkP","empty":"substitutions_empty__b0Wbo"};